import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/constants';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-financial-ranking-suppliers',
  templateUrl: './financial-ranking-suppliers.component.html',
  styleUrls: ['./financial-ranking-suppliers.component.css']
})
export class FinancialRankingSuppliersComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  dataSource: any = {
    chart: {
      numberPrefix: "R$ ",
      theme: "fusion",
      paletteColors: "#005781",
      maxBarHeight: "14",
      showValues: "1",
      placeValuesInside: "0"
    },
    data: []
  }

  selectItem: any = [
    { label: 'Maior valor', value: 1 },
    { label: 'Maior valor em atraso', value: 2 }
  ]
  itemSelected: any = 2;

  branchSelected: any;
  
  loading: boolean = true;
  errorApi: boolean = false;
  message : string = "";

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  changeEventSelect(item: any) {
    this.loading = true;
    if (item == 1) {
      this.itemSelected = 1;
      this.rankingSuppliersBiggestInformation(this.branchSelected)
    } else {
      this.itemSelected = 2;
      this.rankingSuppliersDebtorsInformation(this.branchSelected)
    }
  }

  filterItem(item: any) {
    this.branchSelected = item;
    this.errorApi = false;
    this.loading = true;
    this.changeEventSelect(2);
  }

  rankingSuppliersBiggestInformation(item: any) {
    this.api.postSupplierTopBiggest(item.branch, item.dataMin, item.dataMax).subscribe(data => {
      try {
        this.dataSource.chart.paletteColors = '#005781';
        this.dataSource.data = [];
        if (data.dataRow.length != 0) {
          data.dataRow.map((el:any) => {
            this.dataSource.data.push({
              'label': el.supplier_name,
              'value': el.supplier_value,
              'valueBgColor': '#F9F9F9'
            })
          })
        } else {
          this.message = CONSTANTS.MESSAGES.DATA_NULL_RANKING_SUPPLIERS;
          this.formatErrorMensagem(this.message);
          this.errorApi = true;
        }
        this.loading = false;
      } catch (error: unknown){
        this.loading = false;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_RANKING_SUPPLIERS;
      this.formatErrorMensagem(error.message);
    });
  }

  rankingSuppliersDebtorsInformation(item: any) {
    this.api.postSupplierTopDebtors(item.branch).subscribe(data => {
      try {
        this.dataSource.chart.paletteColors = '#F1726F';
        this.dataSource.data = [];
        if (data.dataRow.length != 0) {
          data.dataRow.map((el:any) => {
            this.dataSource.data.push({
              'label': el.supplier_name,
              'value': el.supplier_value,
              'valueBgColor': '#F9F9F9'
            })
          })
        } else {
          this.message = CONSTANTS.MESSAGES.DATA_NULL_RANKING_SUPPLIERS;
          this.formatErrorMensagem(this.message);
          this.errorApi = true;
        }
        this.loading = false;
      } catch (error: unknown){
        this.loading = false;
        if (error instanceof Error)
          this.formatErrorMensagem(error.message);
      }
    }, error => {
      this.loading = false;
      this.errorApi = true;
      this.message = CONSTANTS.MESSAGES.DATA_ERRO_RANKING_SUPPLIERS;
      this.formatErrorMensagem(error.message);
    });
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: financial-ranking-supplier \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
